export function isMacOS() {
  return navigator.userAgent.toUpperCase().includes('MAC');
}
